// import { Component } from '@angular/core';
// import { Router } from '@angular/router';
// import { ReactiveFormsModule } from '@angular/forms';

// import { AuthService } from '../../core/auth.service';

// @Component({
//   selector: 'user-login',
//   templateUrl: './user-login.component.html',
//   styleUrls: ['./user-login.component.scss'],
// })
// export class UserLoginComponent {

//   constructor(public auth: AuthService,
//               private router: Router) { }

//   /// Social Login

//   async signInWithGithub() {
//     await this.auth.githubLogin();
//     return await this.afterSignIn();
//   }

//   async signInWithGoogle() {
//     await this.auth.googleLogin();
//     return await this.afterSignIn();
//   }

//   async signInWithFacebook() {
//     await this.auth.facebookLogin();
//     await this.afterSignIn();
//   }

//   async signInWithTwitter() {
//     await this.auth.twitterLogin();
//     return await this.afterSignIn();
//   }

//   /// Anonymous Sign In

//   async signInAnonymously() {
//     await this.auth.anonymousLogin();
//     return await this.afterSignIn();
//   }

//   /// Shared

//   private afterSignIn() {
//     // Do after login stuff here, such router redirects, toast messages, etc.
//     return this.router.navigate(['/']);
//   }

// }
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { first } from 'rxjs/operators';

// import { AlertService, AuthenticationService } from '../_services';
import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss'],
})
export class UserLoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;

  constructor(
    public auth: AuthService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    // private authenticationService: AuthenticationService,
    // private alertService: AlertService
    ) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    // reset login status
    this.auth.signOut();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || 'home';
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.auth.emailLogin(this.f.username.value, this.f.password.value).then(() => {
      this.router.navigate([this.returnUrl]);
    }).catch((error) => {
      // this.alertService.error(error);
      this.loading = false;
    });
      // .pipe(first())
      // .subscribe(
      //   data => {
      //     this.router.navigate([this.returnUrl]);
      //   },
      //   error => {
      //     this.alertService.error(error);
      //     this.loading = false;
      //   });
  }
}
